import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import { I18n, DataBlocks } from 'components';
import { CONFIRMATION_POPUP_KEY, EDITING_POPUP_KEY } from './constants';

import PasswordSettings from './components/PasswordSettings';
import NotificationPoints from '../../components/NotificationPoints';
import MobileAccess from './components/MobileAccess';
import InternetAccess from './components/InternetAccess';

import {
  fetchInitialData,
  setPasswordRecoveryChannel,
  togglePointEditingState,
  saveNotificationPoint,
  confirmNotificationPointCode,
  resetNotificationPointCodeValidation,
  sendNotificationPointCode,
  changePassword,
  saveAccessConfig,
  toggleConfirmationCodePopup,
  fetchPoints,
  fetchOffer,
  fetchInternetLogin,
  changeInternetLogin,
  changeInternetPassword,
} from './actions';

const PasswordAndAccess = ({
  actions,
  offer,
  pointsFetchingError,
  offerFetchingError,
  notificationPoints,
  passwordUpdatingStatus,
  internetLoginUpdatingStatus,
  internetPasswordUpdatingStatus,
  accessConfigUpdatingStatus,
  isConfirmationOpened,
  isPointEditing,
  masterLogin,
  isConvergent,
  isPorted,
  internetLogin,
  canChangeInternetLogin,
  internetLoginFetchingError,
  fttbConfigureConnectionHelpUrl,
  passwordPolicy,
}) => {
  useEffect(() => {
    if (!isPorted) {
      actions.fetchInitialData();
    }
  }, [isPorted]);

  return (
    <DataBlocks.Container>
      <PasswordSettings
        userLogin={masterLogin}
        passwordUpdatingStatus={passwordUpdatingStatus}
        changePassword={actions.changePassword}
        isConvergent={isConvergent}
        passwordPolicy={passwordPolicy}
      />

      {!isPorted && (
        <>
          {/* Скрываем пункт меню в рамках патча UPA-2943 */}
          {/*<NotificationPoints*/}
          {/*  title={<I18n path="settings.passwordAndAccess.passwordRecoveryTitle" />}*/}
          {/*  notificationPoints={notificationPoints}*/}
          {/*  isConfirmationOpened={isConfirmationOpened}*/}
          {/*  isPointEditing={isPointEditing}*/}
          {/*  toggleNotificationPoint={actions.setPasswordRecoveryChannel}*/}
          {/*  togglePointEditingState={actions.togglePointEditingState}*/}
          {/*  saveNotificationPoint={actions.saveNotificationPoint}*/}
          {/*  confirmNotificationPointCode={actions.confirmNotificationPointCode}*/}
          {/*  resetNotificationPointCodeValidation={actions.resetNotificationPointCodeValidation}*/}
          {/*  sendNotificationPointCode={actions.sendNotificationPointCode}*/}
          {/*  toggleConfirmationCodePopup={actions.toggleConfirmationCodePopup}*/}
          {/*  error={pointsFetchingError}*/}
          {/*  refreshAction={actions.fetchPoints}*/}
          {/*  isRecoveryPassword*/}
          {/*/>*/}
          <MobileAccess
            {...offer}
            accessConfigUpdatingStatus={accessConfigUpdatingStatus}
            saveAccessConfig={actions.saveAccessConfig}
            error={offerFetchingError}
            refreshAction={actions.fetchOffer}
          />
        </>
      )}

      {isConvergent && (
        <InternetAccess
          userInternetLogin={internetLogin}
          userLogin={masterLogin}
          loginUpdatingStatus={internetLoginUpdatingStatus}
          passwordUpdatingStatus={internetPasswordUpdatingStatus}
          canChangeLogin={canChangeInternetLogin}
          error={internetLoginFetchingError}
          refreshAction={actions.fetchInternetLogin}
          onSubmitLogin={actions.changeInternetLogin}
          onSubmitPassword={actions.changeInternetPassword}
          fttbConfigureConnectionHelpUrl={fttbConfigureConnectionHelpUrl}
          passwordPolicy={passwordPolicy}
        />
      )}
    </DataBlocks.Container>
  );
};

PasswordAndAccess.propTypes = {
  actions: PropTypes.object,
  pointsFetchingError: PropTypes.string,
  offerFetchingError: PropTypes.string,
  notificationPoints: PropTypes.array,
  passwordUpdatingStatus: PropTypes.object,
  internetLoginUpdatingStatus: PropTypes.object,
  internetPasswordUpdatingStatus: PropTypes.object,
  accessConfigUpdatingStatus: PropTypes.object,
  offer: PropTypes.object,
  isConfirmationOpened: PropTypes.bool,
  isPointEditing: PropTypes.bool,
  masterLogin: PropTypes.string,
  isConvergent: PropTypes.bool,
  isPorted: PropTypes.bool,
  internetLogin: PropTypes.string,
  canChangeInternetLogin: PropTypes.bool,
  internetLoginFetchingError: PropTypes.string,
  fttbConfigureConnectionHelpUrl: PropTypes.string,
  passwordPolicy: PropTypes.object,
};

const mapStateToProps = (state) => ({
  pointsFetchingError: state.settings.passwordAndAccess.pointsFetchingError,
  offerFetchingError: state.settings.passwordAndAccess.offerFetchingError,
  internetLoginFetchingError: state.settings.passwordAndAccess.internetLoginFetchingError,
  isInternetLoginFetching: state.settings.passwordAndAccess.isInternetLoginFetching,
  canChangeInternetLogin: state.settings.passwordAndAccess.canChangeInternetLogin,
  internetLogin: state.settings.passwordAndAccess.internetLogin,
  internetLoginUpdatingStatus: state.settings.passwordAndAccess.internetLoginUpdatingStatus,
  internetPasswordUpdatingStatus: state.settings.passwordAndAccess.internetPasswordUpdatingStatus,
  notificationPoints: state.settings.passwordAndAccess.points,
  offer: state.settings.passwordAndAccess.offer,
  passwordUpdatingStatus: state.settings.passwordAndAccess.passwordUpdatingStatus,
  accessConfigUpdatingStatus: state.settings.passwordAndAccess.accessConfigUpdatingStatus,
  isConfirmationOpened: state.application.popup === CONFIRMATION_POPUP_KEY,
  isPointEditing: state.application.popup === EDITING_POPUP_KEY,
  masterLogin: state.application.settings.masterLogin,
  isConvergent: state.application.isConvergent,
  isPorted: state.application.isPorted,
  fttbConfigureConnectionHelpUrl: state.settings.passwordAndAccess.fttbConfigureConnectionHelpUrl,
  passwordPolicy: state.application.settings.passwordPolicy.mobile,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({
    fetchInitialData,
    setPasswordRecoveryChannel,
    togglePointEditingState,
    saveNotificationPoint,
    confirmNotificationPointCode,
    resetNotificationPointCodeValidation,
    sendNotificationPointCode,
    changePassword,
    saveAccessConfig,
    toggleConfirmationCodePopup,
    fetchPoints,
    fetchOffer,
    fetchInternetLogin,
    changeInternetLogin,
    changeInternetPassword,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(PasswordAndAccess);
